import { useEffect, useRef } from "react";
import { Dokument, Kalender, Liste, Ordner, Raster, Sprechblase, Zahnrad } from "./Symbole";

/*
  Das feste Menü.

  Auf dem iPad im Querformat steht es als schmale Spalte links und bleibt immer
  sichtbar. Auf schmalen Geräten wird daraus eine waagerechte Leiste unter der
  Kopfzeile, die sich seitlich schieben lässt — so ist es immer da und
  versteckt sich nicht hinter einem Knopf.
*/

export const MENUE = [
  { schluessel: "dashboard", titel: "Dashboard", symbol: Raster },
  { schluessel: "sitzung", titel: "Sitzung", symbol: Kalender },
  { schluessel: "chats", titel: "Chats", symbol: Sprechblase },
  { schluessel: "aufgaben", titel: "Aufgaben", symbol: Liste },
  { schluessel: "office", titel: "Office", symbol: Dokument },
  { schluessel: "dateien", titel: "Dateien und Akten", symbol: Ordner },
];

/* Welcher Menüpunkt ist bei welcher Ansicht hervorgehoben? */
const ZUORDNUNG = {
  dashboard: "dashboard",
  sitzung: "sitzung",
  chats: "chats",
  aufgaben: "aufgaben",
  office: "office",
  dateien: "dateien",
  /* Ein offenes Dokument gehört zu Office — das Menü zeigt das auch so. */
  textdokument: "office",
  praesentation: "office",
};

export function aktiverMenuepunkt(ansichtName) {
  return ZUORDNUNG[ansichtName] || null;
}

export default function Menue({ aktiv, oeffne, aufEinstellungen }) {
  const aktiverKnopf = useRef(null);

  /*
    Den aktiven Punkt sichtbar machen.

    Auf dem Handy ist das Menü eine seitlich schiebbare Leiste, und seit
    „Office“ dazugekommen ist, passen nicht mehr alle Punkte hinein. Ohne
    dieses Nachziehen stünde man in Office und sähe im Menü nur „Dashboard“
    und „Sitzung“ — ohne jede Hervorhebung. Man wüsste nicht, wo man ist.
  */
  useEffect(() => {
    const knopf = aktiverKnopf.current;
    if (!knopf) return;
    knopf.scrollIntoView({ block: "nearest", inline: "nearest" });
  }, [aktiv]);

  return (
    <nav className="menue" aria-label="Hauptmenü">
      <ul className="menue__liste">
        {MENUE.map((punkt) => (
          <li key={punkt.schluessel}>
            <button
              ref={aktiv === punkt.schluessel ? aktiverKnopf : undefined}
              className="menue__punkt"
              title={punkt.titel}
              aria-label={punkt.titel}
              aria-current={aktiv === punkt.schluessel ? "page" : undefined}
              onClick={() => oeffne(punkt.schluessel, {})}
            >
              <punkt.symbol groesse={20} />
              <span className="menue__text">{punkt.titel}</span>
            </button>
          </li>
        ))}

        <li className="menue__abstand">
          <button
            className="menue__punkt"
            title="Einstellungen"
            aria-label="Einstellungen"
            onClick={aufEinstellungen}
          >
            <Zahnrad groesse={20} />
            <span className="menue__text">Einstellungen</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
